import {
  Download, Eye, FileSignature, FileText, GitCompare, ShieldCheck, Trash2,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { DOCUMENT_TYPE_LABELS, DOCUMENT_TYPE_ICONS, STATUS_VARIANTS, formatBytes } from "./Exports.constants";

export default function DocumentRow({ doc, canWrite, openPreview, openDiff, download, setSignDoc, updateStatus, remove }) {
  const Icon = DOCUMENT_TYPE_ICONS[doc.document_type] || FileText;
  const promotedId = doc.metadata?.promoted_company_document_id;
  const signed = doc.metadata?.signed;
  return (
    <div className="flex flex-col gap-3 rounded-md border border-slate-200 p-4 sm:flex-row sm:items-center sm:justify-between" data-testid={`generated-row-${doc.id}`}>
      <div className="flex items-start gap-3">
        <Icon className="mt-1 h-5 w-5 text-blue-900" />
        <div>
          <p className="font-semibold text-slate-950" data-testid={`generated-name-${doc.id}`}>{DOCUMENT_TYPE_LABELS[doc.document_type] || doc.document_type}</p>
          <p className="text-sm text-slate-500" data-testid={`generated-meta-${doc.id}`}>v{doc.version_number} · {doc.file_name} · {formatBytes(doc.file_size)} · generato da {doc.generated_by_name || "—"} il {new Date(doc.generated_at).toLocaleString("it-IT")}</p>
          <div className="mt-2 flex flex-wrap gap-2">
            <Badge className={STATUS_VARIANTS[doc.status] || STATUS_VARIANTS.bozza} data-testid={`generated-status-${doc.id}`}>{doc.status}</Badge>
            {doc.sha256 && <Badge className="bg-slate-100 text-slate-700 font-mono text-[10px]">SHA {doc.sha256.slice(0, 10)}…</Badge>}
            {doc.dvr_assessment_id && <Badge className="bg-blue-50 text-blue-900"><ShieldCheck className="mr-1 h-3 w-3" />DVR collegato</Badge>}
            {promotedId && <Badge className="bg-emerald-50 text-emerald-700" data-testid={`generated-promoted-${doc.id}`}>Promosso in Documenti</Badge>}
            {signed && <Badge className="bg-violet-50 text-violet-700" data-testid={`generated-signed-${doc.id}`}><FileSignature className="mr-1 h-3 w-3" /> Firmato eIDAS</Badge>}
          </div>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Button variant="outline" size="sm" onClick={() => openPreview(doc)} data-testid={`preview-generated-${doc.id}`}><Eye className="h-4 w-4" /> Anteprima</Button>
        <Button variant="outline" size="sm" onClick={() => openDiff(doc)} data-testid={`diff-generated-${doc.id}`}><GitCompare className="h-4 w-4" /> Confronta</Button>
        <Button variant="outline" size="sm" onClick={() => download(doc)} data-testid={`download-generated-${doc.id}`}><Download className="h-4 w-4" /> Scarica</Button>
        {canWrite && (
          <Button variant="outline" size="sm" onClick={() => setSignDoc(doc)} data-testid={`sign-generated-${doc.id}`}><FileSignature className="h-4 w-4" /> Firma</Button>
        )}
        {canWrite && (
          <select
            className="h-9 rounded-md border border-slate-200 bg-white px-3 text-sm"
            value={doc.status}
            onChange={(e) => updateStatus(doc, e.target.value)}
            data-testid={`status-select-${doc.id}`}
          >
            <option value="bozza">Bozza</option>
            <option value="finale">Finale</option>
            <option value="archiviato">Archiviato</option>
          </select>
        )}
        {canWrite && <Button variant="outline" size="sm" className="text-red-700" onClick={() => remove(doc)} data-testid={`delete-generated-${doc.id}`}><Trash2 className="h-4 w-4" /> Elimina</Button>}
      </div>
    </div>
  );
}
